module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG47c30b7fe3694047b5a6de10fbfe0144.47c30b7f.png";